module.exports = __webpack_public_path__ + "static/pick_return-1582f1320437135b8da8c8eade9b8c2d.jpg";